import { render } from "./floating.vue?vue&type=template&id=5c07ef44&scoped=true"
import script from "./floating.vue?vue&type=script&lang=js"
export * from "./floating.vue?vue&type=script&lang=js"

import "./floating.vue?vue&type=style&index=0&id=5c07ef44&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.www/src/fe-www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c07ef44"]])

export default __exports__